import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import JsonLd from '../JsonLd/JsonLd';
import { buildOrganizationLd } from '../../data/businessInfo';

export default function Layout() {
	const [showTop, setShowTop] = useState(false);

	useEffect(() => {
		const onScroll = () => setShowTop(window.scrollY > 400);
		window.addEventListener('scroll', onScroll, { passive: true });
		return () => window.removeEventListener('scroll', onScroll);
	}, []);

	return (
		<div className="page">
			{/* Sitewide Organization / AutomotiveBusiness JSON-LD (emitted once per route).
			    Also the prerenderer's "Helmet has committed" marker on routes without their
			    own JSON-LD — see scripts/prerender.mjs routeMarker(). */}
			<JsonLd data={buildOrganizationLd()} />
			<Header />
			<main>
				<Outlet />
			</main>
			<Footer />
			<button
				type="button"
				className={`backtop ${showTop ? 'is-visible' : ''}`}
				aria-label="Vissza az oldal tetejére"
				onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
			>
				<svg viewBox="0 0 24 24" fill="none"><path d="M5 14l7-7 7 7" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
			</button>
		</div>
	);
}
